import fr_FR from './translations/fr_FR/translations.json';
import en_US from './translations/en_US/translations.json';

export default {
  fr_FR,
  en_US
};
